import { useContext } from 'react'

import { FollowUpAlertContext } from '@provider/Alerts/FollowUpProvider'

import type { IFollowUpAlertContext } from '@base/@types/providers/Alert/FollowUpProvider'

export default function useFollowUpAlert(): IFollowUpAlertContext {
  const context = useContext(FollowUpAlertContext)

  return context
}
